module.exports = __webpack_public_path__ + "assets/fabbfecdf4b9f45c93a1446da03f1ce8.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/denoms/denom_25.mp3
 ** module id = 47
 ** module chunks = 0
 **/